import styled from 'styled-components';

const SlideoutLoaderContainer = styled.div`
  margin-top: 56px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

export default SlideoutLoaderContainer;
